import { useState , useEffect} from "react";
import { Link } from "react-router-dom";
import Menu from './MenuPage';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import Modal from "./Modal";
import PacienteCrud from "./Paciente";
import TutorCrud from "./TutorCrud";
import LoadingOverlay from "./LoadingOverlay";
export default function ExameForm() {



    // ------------------ ESTADOS ------------------

    const [form, setForm] = useState({
        dataExame: "",
        dataLaudo: "",
        clinica: "",
        solicitante: "",
        descricao: "",
        idTipoExame: "",
        idTutor: null,
        idPaciente: null,
    });

    const [orgaosSelecionados, setOrgaosSelecionados] = useState([]);
    const [imagens, setImagens] = useState([]);
    const [orgaosAbertos, setOrgaosAbertos] = useState([]);
    const [tiposExame, setTiposExame] = useState([]);
    const [tutores, setTutores] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [pacientesFiltrados, setPacientesFiltrados] = useState([]);
    const [orgaos, setOrgaos] = useState([]);
    const [orgaosFiltrados, setOrgaosFiltrados] = useState([]);
    const [erros, setErros] = useState([]);
    const [caracteristicas, setCaracteristicas] = useState([]);
    const [exemplosCaracteristica, setExemplosCaracteristica] = useState([]);
    const [showTutorModal, setShowTutorModal] = useState(false);
    const [showPacienteModal, setShowPacienteModal] = useState(false);
    const [loading, setLoading] = useState(false);

    /*Atualizar dropdown de tutores e pacientes após clicar em novo*/
    const atualizarTutores = async (novoTutorId = null) => {
   // const idUsuario = localStorage.getItem("idUsuario");
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE_URL}/tutor/getAll`, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
    setTutores(response.data);
    console.log(novoTutorId)
    if (novoTutorId) {
        setForm(prev => ({ ...prev, idTutor: novoTutorId }));
    }
    };

    const atualizarPacientes = async (novoPacienteId = null) => {
   // const idUsuario = localStorage.getItem("idUsuario");
    const token = localStorage.getItem("token");
    const response = await axios.get(`${API_BASE_URL}/paciente/getAll`, {
                headers: { "Authorization": `Bearer ${token}` }
         
            });
    setPacientes(response.data);

    if (novoPacienteId) {
        setForm(prev => ({ ...prev, idPaciente: novoPacienteId }));
    }
    };
 

    // ------------------ CARREGAR SELECTS ------------------
    useEffect(() => {
        carregarSelects();
    }, []);

    const carregarSelects = async () => {
        try {
            //const idUsuario = localStorage.getItem("idUsuario");
            const token = localStorage.getItem("token");
            const config = {
              headers: { Authorization: `Bearer ${token}` }
            };
            const [
                tiposExameResponse,
                tutoresResponse,
                pacientesResponse,
                orgaosResponse,
                caracteristicasResponse,
                exemplosResponse,
                ] = await Promise.all([
                 axios.get(`${API_BASE_URL}/tipoexame`, config),
                 axios.get(`${API_BASE_URL}/tutor/getAll`, config),
                 axios.get(`${API_BASE_URL}/paciente/getAll`, config),
                 axios.get(`${API_BASE_URL}/Orgao`, config),
                 axios.get(`${API_BASE_URL}/OrgaoCaracteristica`, config) ,
                 axios.get(`${API_BASE_URL}/OrgaoCaracteristicaExemplo`, config) 
            ]);

            setTiposExame(tiposExameResponse.data);
            setTutores(tutoresResponse.data);
            setOrgaos(orgaosResponse.data);
            setPacientes(pacientesResponse.data);
            setCaracteristicas(caracteristicasResponse.data);
            setExemplosCaracteristica(exemplosResponse.data);
        } catch (err) {
            console.error("Erro ao carregar selects:", err);
        }
    };


    
    // ------------------ EFEITO PARA FILTRAR PACIENTES E ÓRGÃOS ------------------
    useEffect(() => {
        // Filtra pacientes por tutor
        if (form.idTutor) {
            const tutorselecionado = Number(form.idTutor);
            const filtrados = pacientes.filter(p => p.idTutor === tutorselecionado);
            setPacientesFiltrados(filtrados);
        } else {
            setPacientesFiltrados([]);
        }

        // Filtra órgãos por tipo de exame
        if (form.idTipoExame) {
            const tipoexameselecionado = Number(form.idTipoExame);
            const filtrados = orgaos.filter(orgao => orgao.idTipoExame === tipoexameselecionado);
            setOrgaosFiltrados(filtrados);
        } else {
            setOrgaosFiltrados([]);
        }

    }, [form.idTutor, pacientes, form.idTipoExame, orgaos]);

    // ------------------ LIMPAR TELA ------------------
    const limparTela = () => {
        setForm({
            dataExame: "",
            dataLaudo: "",
            clinica: "",
            solicitante: "",
            descricao: "",
            idTipoExame: "",
            idTutor: null,
            idPaciente: null,
        });

        setOrgaosSelecionados([]);
        setOrgaosAbertos([]);
        setImagens([]);
        setErros([]);
    };

    // ------------------ VALIDAÇÃO ------------------
    const validarFormulario = () => {
        const errosLocal = [];

        if (!form.dataExame) errosLocal.push("Preencha a data do exame.");
        if (!form.dataLaudo) errosLocal.push("Preencha a data do laudo.");
        if (!form.idTipoExame) errosLocal.push("Selecione o tipo de exame.");
        if (!form.idTutor) errosLocal.push("Selecione um tutor.");
        if (!form.idPaciente) errosLocal.push("Selecione um paciente.");

        for (let i = 0; i < orgaosSelecionados.length; i++) {
            const orgao = orgaosSelecionados[i];

            if (!orgao.idOrgao) {
                errosLocal.push(`Selecione um órgão no item ${i + 1}.`);
                continue;
            }

            for (let j = 0; j < orgao.caracteristicas.length; j++) {
                const car = orgao.caracteristicas[j];

                // agora que carregamos automaticamente, car.idCaracteristica já existe.
                if (!car.idCaracteristica) {
                    errosLocal.push(`Característica faltando no órgão ${i + 1}, item ${j + 1}.`);
                }

                if (!car.texto || car.texto.trim() === "") {
                    errosLocal.push(`Preencha o texto da característica no órgão ${i + 1}, item ${j + 1}.`);
                }
            }
        }

        setErros(errosLocal);
        return errosLocal.length === 0;
    };

    // ------------------ ADICIONAR / REMOVER ORGÃO ------------------
    const adicionarOrgao = () => {
        setOrgaosSelecionados(prev => [
            ...prev,
            { idOrgao: "", caracteristicas: [] }
        ]);

        // novo órgão entra aberto
        setOrgaosAbertos(prev => [...prev, true]);
    };

    const toggleOrgao = (index) => {
        const copia = [...orgaosAbertos];
        copia[index] = !copia[index];
        setOrgaosAbertos(copia);
    };

    const removerOrgao = (index) => {
        const copia = [...orgaosSelecionados];
        copia.splice(index, 1);
        setOrgaosSelecionados(copia);

        // remove também do estado de abertos para manter indices consistentes
        const copiaAbertos = [...orgaosAbertos];
        copiaAbertos.splice(index, 1);
        setOrgaosAbertos(copiaAbertos);
    };

    // ------------------ CARACTERÍSTICAS AUTOMÁTICAS ------------------
    // Quando o usuário seleciona um órgão em um bloco, preenche as características desse órgão
    const onChangeOrgaoSelecionado = (iOrgao, value) => {
    const id = value === "" ? "" : Number(value);
    const copia = [...orgaosSelecionados];
    copia[iOrgao].idOrgao = id;

    if (id) {
        const lista = caracteristicas
            .filter(c => c.idOrgao === id)
            .map(c => ({
                idCaracteristica: c.id,
                nomeCaracteristica: c.descricao,
                texto: ""
            }));

        copia[iOrgao].caracteristicas = lista;
    } else {
        copia[iOrgao].caracteristicas = [];
    }

    setOrgaosSelecionados(copia);
    };


    const removerCaracteristica = (iOrgao, iCar) => {
        const copia = [...orgaosSelecionados];
        if (!copia[iOrgao]) return;
        copia[iOrgao].caracteristicas.splice(iCar, 1);
        setOrgaosSelecionados(copia);
    };

    // ------------------ IMAGENS ------------------
    const handleImagem = (e) => {
        const files = Array.from(e.target.files);
        setImagens(prev => [...prev, ...files]);
    };

    const removerImagem = (index) => {
        const copia = [...imagens];
        copia.splice(index, 1);
        setImagens(copia);
    };

    // ------------------ SALVAR / FINALIZAR ------------------
    const salvar = () => {
        if (!validarFormulario()) return;

        console.log("Salvando...", form, orgaosSelecionados, imagens);
        alert("Salvo com sucesso!");
    };

    const   finalizar = async  () => {

        //const [loading, setLoading] = useState(false);

        try {
            setLoading(true); // inicia carregamento

            if (!validarFormulario()) return;


            const formData = new FormData();
            const idUsuario = localStorage.getItem("idUsuario");
            formData.append("IdPaciente", form.idPaciente);
            formData.append("Idusuario", idUsuario);
            formData.append("DataExame", form.dataExame);
            formData.append("DataLaudo", form.dataLaudo);
            formData.append("Clinica", form.clinica);
            formData.append("Solicitante", form.solicitante);
            formData.append("Descricao", form.descricao);
            formData.append("IdTipoExame", form.idTipoExame);
            let contCaracteristica = 0;
            // Características   
            orgaosSelecionados.forEach((c, index) => {
                const orgao = orgaosSelecionados[index];
                //formData.append(`Orgaos[${index}].IdOrgao`, c.idOrgao);
            
                for (let j = 0; j < orgao.caracteristicas.length; j++) {
                 const car = orgao.caracteristicas[j];

                 formData.append(`ExameCaracteristica[${contCaracteristica}].IdCaracteristica`, car.idCaracteristica);
                 formData.append(`ExameCaracteristica[${contCaracteristica}].Descricao`, car.texto);
                 contCaracteristica++;
                }
            });

            // Imagens
            imagens.forEach(img => {
                formData.append("Imagens", img);
            });
    
            console.log(formData);

            const token = localStorage.getItem("token");

             const response = await axios.post(`${API_BASE_URL}/exame/salvar`, formData, {
                headers: { "Content-Type": "multipart/form-data",  "Authorization": `Bearer ${token}` }
         
            });

        

            console.log(response.data);
        
            alert("Laudo finalizado! Código: " + response.data.idExame);

            // pega o id retornado
            const id = response.data.idExame;

            if (id) {
             // agora baixa o PDF
                await baixarPdf(id);
            }

            limparTela();

            } 
            catch (error) {
                console.error(error);
                alert("Erro ao salvar ou gerar PDF.");
            } finally {
                setLoading(false); // encerra carregamento
            }
    };

    const baixarPdf = async (id) => {
    try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/exame/${id}/pdf`, {
            responseType: "blob",
            headers: { "Authorization": `Bearer ${token}` }
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `laudo_${id}.pdf`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        link.remove();

    } catch (error) {
        console.error("Erro ao baixar PDF", error);
    }
    };

    // ------------------ HANDLE CHANGE (formularios) ------------------
    // corrigi para usar value direto e atualizar filtros imediatamente
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prevForm => ({ ...prevForm, [name]: value }));

        // atualizar filtragens baseadas no novo value (evita stale state)
        if (name === "idTutor") {
            if (value) {
                const tutorselecionado = Number(value);
                const pacientesFiltrados = pacientes.filter(paciente => paciente.idTutor === tutorselecionado);
                setPacientesFiltrados(pacientesFiltrados);
            } else {
                setPacientesFiltrados([]);
            }
        }

        if (name === "idTipoExame") {
            if (value) {
                const tipoexameselecionado = Number(value);
                const filtrados = orgaos.filter(orgao => orgao.idTipoExame === tipoexameselecionado);
                setOrgaosFiltrados(filtrados);
            } else {
                setOrgaosFiltrados([]);
            }
        }
    };

    // ------------------ RENDER ------------------
    return (

<div >
            <Menu />
         

        <div className="container mt-4">
            <h3>Cadastro de Laudo de Exame</h3>
            <hr />

            {/* mostra lista de erros se houver */}
            {erros.length > 0 && (
                <div className="alert alert-danger">
                    <ul className="mb-0">
                        {erros.map((err, idx) => <li key={idx}>{err}</li>)}
                    </ul>
                </div>
            )}

            {/* DATA DO EXAME */}
            <div className="row">
                <div className="col-md-3">
                    <label>Data do Exame</label>
                    <input type="date" 
                        className="form-control"
                        value={form.dataExame}
                        onChange={(e)=> handleChange({ target: { name: 'dataExame', value: e.target.value } })}
                    />
                </div>

                <div className="col-md-3">
                    <label>Data do Laudo</label>
                    <input type="date" 
                        className="form-control"
                        value={form.dataLaudo}
                        onChange={(e)=> handleChange({ target: { name: 'dataLaudo', value: e.target.value } })}
                    />
                </div>

                <div className="col-md-3">
                    <label>Tipo de Exame</label>
                    <select 
                        className="form-control"
                        value={form.idTipoExame}
                        name="idTipoExame"
                        onChange={handleChange}
                    >
                        <option value="">Selecione</option>
                        {tiposExame.map(t => (
                            // alguns endpoints usam 'descricao' outros 'nome' -> tento ambos
                            <option key={t.id} value={t.id}>{t.descricao ?? t.nome}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* CLÍNICA E SOLICITANTE */}
            <div className="row mt-3">
                <div className="col-md-6">
                    <label>Clínica</label>
                    <input className="form-control"
                        value={form.clinica}
                        onChange={(e)=> handleChange({ target: { name: 'clinica', value: e.target.value } })}
                    />
                </div>

                <div className="col-md-6">
                    <label>Solicitante</label>
                    <input className="form-control"
                        value={form.solicitante}
                        onChange={(e)=> handleChange({ target: { name: 'solicitante', value: e.target.value } })}
                    />
                </div>
            </div>

            {/* TUTOR e PACIENTE */}
            <div className="row mt-3">
                <div className="col-md-6">
                    <label>Tutor</label>
                    <div className="d-flex gap-2">
                        <select className="form-control"  name="idTutor" value={form.idTutor ?? ""} onChange={handleChange}>
                            <option value="">Selecione um tutor</option>
                            {tutores.map((tutor) => (
                                <option key={tutor.id} value={tutor.id}>{tutor.nome}</option>
                            ))}
                        </select>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => setShowTutorModal(true)}
                            >
                             Novo
                        </button>

                    </div>
                </div>

                <div className="col-md-6">
                    <label>Paciente</label>
                    <div className="d-flex gap-2">
                        <select className="form-control"  name="idPaciente" value={form.idPaciente ?? ""} onChange={handleChange}>
                            <option value="">Selecione um paciente</option>
                              {pacientesFiltrados.map((paciente) => (
                            <option key={paciente.id} value={paciente.id}>{paciente.nome}</option>
                        ))}
                        </select>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => setShowPacienteModal(true)}
                        >
                            Novo
                        </button>

                    </div>
                </div>
            </div>

            {/* DESCRIÇÃO */}
            <div className="mt-3">
                <label>Descrição Geral</label>
                <textarea 
                    className="form-control"
                    rows={4}
                    value={form.descricao}
                    onChange={(e)=> handleChange({ target: { name: 'descricao', value: e.target.value } })}
                ></textarea>
            </div>

            {/* ÓRGÃOS ANALISADOS */}
            <div className="mt-4">
                <h5>Órgãos Analisados</h5>

                {orgaosSelecionados.map((o, iOrgao) => {
                    // tenta obter o nome pelo array de órgãos (pode vir 'descricao' do backend)
                    const orgaoSelecionado = orgaos.find(x => Number(x.id) === Number(o.idOrgao));
                    const nomeOrgao = orgaoSelecionado ? (orgaoSelecionado.descricao ?? orgaoSelecionado.nome) : null;

                    return (
                        <div key={iOrgao} className="border rounded p-3 mt-3">

                            {/* CABEÇALHO CLICÁVEL */}
                            <div
                                className="d-flex justify-content-between align-items-center"
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleOrgao(iOrgao)}
                            >
                                <h6 className="mb-0">
                                    {orgaosAbertos[iOrgao] ? "▼ " : "► "}
                                    {nomeOrgao ? nomeOrgao : `Órgão ${iOrgao + 1}`}
                                </h6>

                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        removerOrgao(iOrgao);
                                    }}
                                >
                                    Remover
                                </button>
                            </div>

                            {/* ÁREA RECOLHÍVEL */}
                            <div
                                className={
                                    "collapse-container mt-3 " +
                                    (orgaosAbertos[iOrgao] ? "collapse-open" : "collapse-closed")
                                }
                            >
                                {/* Seletor do órgão */}
                                <select 
                                    className="form-control"
                                    value={o.idOrgao || ""}
                                    onChange={(e)=> onChangeOrgaoSelecionado(iOrgao, e.target.value)}
                                >
                                    <option value="">Selecione o órgão</option>
                                    {orgaosFiltrados.map(org => (
                                        <option key={org.id} value={org.id}>{org.descricao ?? org.nome}</option>
                                    ))}
                                </select>

                                {/* Características (preenchidas automaticamente ao selecionar órgão) */}
                                {o.caracteristicas.map((c, iCar) => (
                                    <div key={iCar} className="mt-3 p-3 border rounded ">
                                        <div className="d-flex justify-content-between align-items-center gap-3">
                                            <strong>{c.nomeCaracteristica}</strong>
                                             {/* Dropdown de textos prontos (se existir para essa característica) */}
                            {exemplosCaracteristica.some(ex => ex.idCaracteristica === c.idCaracteristica) && (
                <select
        className="form-control"
        value={c.texto || ""}
        onChange={(e) => {
            const copia = [...orgaosSelecionados];
            copia[iOrgao].caracteristicas[iCar].texto = e.target.value;
            setOrgaosSelecionados(copia);
        }}
    >
        <option value="">Escolher texto pronto</option>

        {exemplosCaracteristica
            .filter(ex => ex.idCaracteristica === c.idCaracteristica)
            .map((ex, idx) => (
                <option key={idx} value={ex.descricao}>{ex.descricao}</option>
            ))
        }
    </select>
                )}

                                            <button 
                                                className="btn btn-danger btn-sm"
                                                onClick={()=> removerCaracteristica(iOrgao, iCar)}
                                            >
                                                Remover
                                            </button>
                                        </div>

                                       

                                        {/* Texto editável */}
                                        <textarea 
                                            className="form-control mt-2"
                                            placeholder="Texto da característica"
                                            value={c.texto}
                                            onChange={(e)=>{
                                                const copia = [...orgaosSelecionados];
                                                copia[iOrgao].caracteristicas[iCar].texto = e.target.value;
                                                setOrgaosSelecionados(copia);
                                            }}
                                        ></textarea>
                                    </div>
                                ))}

                                {/* opcional: permitir adicionar manualmente mais características (se quiser manter) */}
                                
                            </div>

                        </div>
                    );
                })}

                <button className="btn btn-primary mt-3" onClick={adicionarOrgao}>
                    + Adicionar Órgão
                </button>
            </div>

            {/* IMAGENS */}
            <div className="mt-4">
                <h5>Imagens do Exame</h5>

                <input 
                    type="file"
                    multiple
                    className="form-control"
                    onChange={handleImagem}
                />

                <div className="row mt-3">
                    {imagens.map((img, idx) => (
                        <div className="col-md-3 mt-2" key={idx}>
                            <div className="border p-2 text-center">
                                <img 
                                    src={URL.createObjectURL(img)} 
                                    alt="" 
                                    className="img-fluid rounded"
                                />
                                <button 
                                    className="btn btn-danger btn-sm mt-2"
                                    onClick={()=> removerImagem(idx)}
                                >
                                    Remover
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* BOTÕES */}
            <div className="mt-4 d-flex gap-3">

                <button className="btn btn-secondary ml-2" onClick={limparTela}>Cancelar</button>
                <button className="btn btn-primary" onClick={finalizar} >Salvar</button>
            </div>
             {loading && <LoadingOverlay />}
            <br/><br/>
        </div>

        {showTutorModal && (
        <Modal title="Novo Tutor" onClose={() => setShowTutorModal(false)}>
        <TutorCrud 
            onSave={(novoTutor) => {
                setShowTutorModal(false);
                atualizarTutores(novoTutor.id); // atualiza lista
            }}
        />
        </Modal>
        )}

    {showPacienteModal && (
    <Modal title="Novo Paciente" onClose={() => setShowPacienteModal(false)}>
        <PacienteCrud 
            onSave={(novoPaciente) => {
                setShowPacienteModal(false);
                atualizarPacientes(novoPaciente.id); // atualiza lista
            }}
        />
    </Modal>
    )}

</div>
    );
}
